const rand = int => {
  return Math.floor(Math.random() * int)
}

const getRandomElementFromArray = array => {
  return array[Math.floor(Math.random() * array.length)]
}

const getPageOfArray = (array, start_index, page_size) => {
  return array.slice(start_index, start_index + page_size)
}

const createKeywordsArrayFromSession = session => {
  let keywords = []

  if (session.keywords && typeof session.keywords === 'string') {
    const trimmed = session.keywords.trim()

    if (trimmed) {
      keywords.push(trimmed)
    }
  } else {
    session.wordmark ? keywords.push(session.wordmark) : null
    session.slogan ? keywords.push(session.slogan) : null
    session.industry ? keywords.push(session.industry.name) : null
  }

  return keywords
}

/**
 * Converts a String into a kebab-cased-slug
 *
 * @param {String} text The text to be converted
 */
function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

/**
 * Converts the Route into an Array, and filters out empty entries
 *
 * @param {object} $route The Nuxt Route instance
 */
const routeToArray = ({ path = '' }) => path.split('/').filter(Boolean)

/**
 * Pick a random element from an array
 */

const pickRandomFromArray = arr => arr[Math.floor(Math.random() * arr.length)]

export {
  rand,
  slugify,
  routeToArray,
  getPageOfArray,
  getRandomElementFromArray,
  createKeywordsArrayFromSession,
  pickRandomFromArray,
}
